import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface CreateReferencePayload {
  interaction_id: string;
  reference_id: string;
  name: string;
}

export interface ReferenceItem {
  id: string;
  user_id: string;
  source_archive_id?: string | null;
  name: string;
  file_path: string;
  file_name: string;
  tag?: {
    id: string;
    name: string;
    text_color: string;
    bg_color: string;
  } | null;
  data?: Record<string, any>;
  created_at: string;
  updated_at: string;
}

export interface GetReferenceResponse {
  message: string;
  reference: ReferenceItem;
}

export interface UpdateReferencePayload {
  prediction: Record<string, any>;
}

export interface ListReferencesResponse {
  message: string;
  references: ReferenceItem[];
  total: number;
  page: number;
  page_size: number;
  total_pages: number;
}

@Injectable({ providedIn: 'root' })
export class ReferencesService {
  private baseUrl = '/api/references';

  constructor(private http: HttpClient) {}

  listReferences(tag?: string, search?: string, page: number = 1, pageSize: number = 10): Observable<ListReferencesResponse> {
    let url = `${this.baseUrl}?page=${page}&page_size=${pageSize}`;
    if (tag) {
      url += `&tag=${encodeURIComponent(tag)}`;
    }
    if (search) {
      url += `&search=${encodeURIComponent(search)}`;
    }
    return this.http.get<ListReferencesResponse>(url);
  }

  getReference(referenceId: string): Observable<GetReferenceResponse> {
    return this.http.get<GetReferenceResponse>(`${this.baseUrl}/${referenceId}`);
  }

  createReference(resultId: string, payload: CreateReferencePayload): Observable<any> {
    return this.http.post(`${this.baseUrl}/${resultId}`, payload);
  }

  updateReference(referenceId: string, payload: UpdateReferencePayload): Observable<any> {
    return this.http.patch(`${this.baseUrl}/${referenceId}`, payload);
  }

  renameReference(referenceId: string, name: string): Observable<any> {
    return this.http.patch(`${this.baseUrl}/${referenceId}/rename`, { name });
  }

  deleteReference(referenceId: string): Observable<any> {
    return this.http.delete(`${this.baseUrl}/${referenceId}`);
  }
}
